import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import './my-watermark.scss';
const defaultProps = {
    width: 120,
    height: 64,
};
const defaultOptions = {
    gapX: 24,
    gapY: 48,
    rotate: -22,
    fontWeight: 'normal',
    fontSize: 14,
    fontFamily: 'sans-serif',
    fontColor: '#E8EAEC',
    fontStyle: 'normal',
};
export const CnWaterMark = (p) => {
    const props = { ...defaultOptions, ...defaultProps, ...p };
    const { zIndex = 2000, image, imageWidth = 120, imageHeight = 64, content, fontStyle, fontColor, gapX, gapY, width, height, rotate, fontSize, fontFamily, fontWeight, } = props;
    const [base64Url, setBase64Url] = useState('');
    useEffect(() => {
        const canvas = document.createElement('canvas');
        const ratio = window.devicePixelRatio;
        const ctx = canvas.getContext('2d');
        const canvasWidth = `${(gapX + width) * ratio}px`;
        const canvasHeight = `${(gapY + height) * ratio}px`;
        const markWidth = width * ratio;
        const markHeight = height * ratio;
        canvas.setAttribute('width', canvasWidth);
        canvas.setAttribute('height', canvasHeight);
        if (ctx) {
            if (image) {
                ctx.translate(markWidth / 2, markHeight / 2);
                ctx.rotate((Math.PI / 180) * Number(rotate));
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.referrerPolicy = 'no-referrer';
                img.src = image;
                img.onload = () => {
                    ctx.drawImage(img, (-imageWidth * ratio) / 2, (-imageHeight * ratio) / 2, imageWidth * ratio, imageHeight * ratio);
                    ctx.restore();
                    setBase64Url(canvas.toDataURL());
                };
            }
            else if (content) {
                ctx.textBaseline = 'middle';
                ctx.textAlign = 'center';
                // 文字绕中间旋转
                ctx.translate(markWidth / 2, markHeight / 2);
                ctx.rotate((Math.PI / 180) * Number(rotate));
                const markSize = Number(fontSize) * ratio;
                ctx.font = `${fontStyle} normal ${fontWeight} ${markSize}px/${markHeight}px ${fontFamily}`;
                ctx.fillStyle = fontColor;
                ctx.fillText(content, 0, 0);
                ctx.restore();
                setBase64Url(canvas.toDataURL());
            }
        }
        else {
            throw new Error('Canvas is not supported');
        }
    }, [
        gapX,
        gapY,
        rotate,
        fontStyle,
        fontWeight,
        width,
        height,
        fontFamily,
        fontColor,
        image,
        content,
        fontSize,
        imageHeight,
        imageWidth,
    ]);
    return withNativeProps(props, React.createElement("div", { style: {
            zIndex,
            backgroundSize: `${gapX + width}px`,
            backgroundImage: `url('${base64Url}')`,
        }, className: cx(['cn-ui-m-water-mark', 'cn-ui-m-styledWaterMark']) }));
};
